if (!customElements.get("select-plan")) {
  class SelectPlan extends HTMLElement {
    constructor() {
      super();
      this.item = this.dataset.item;
      this.select = this.querySelector("select");
      this.selectedPlanId = this.dataset.selectedPlanId;
      this.selectedPlanName = this.dataset.selectedPlanName;
      this.planCheckbox = this.querySelector("[type=checkbox]");
      this.getPlanValues();
    }

    getPlanValues() {
      getCartPlans(this);

      this.planCheckbox.checked 
        ? displayText(this, true)
        : displayText(this, false);

      // checkboxUpdate(this);
      selectUpdate(this);

      function checkboxUpdate(selector) {
        var checkbox = selector.querySelector("[type=checkbox]");

        checkbox.addEventListener("change", (e) => {
          var parent = e.target.closest("select-plan");
          var item = parent.closest(".item");
          var select = parent.querySelector("select");
          var cartItem = null;

          if (e.target.checked) {
            getCartPlans(parent);
            displayText(parent, true);
            cartItem = {
              id: `${parent.dataset.item}`,
              quantity: `${item.querySelector(".quantity-input").value}`,
              selling_plan: `${select.options[select.selectedIndex].value}`,
            };
            updatePlan(cartItem);
          } else {
            displayText(parent, false);
            cartItem = {
              id: `${parent.dataset.item}`,
              quantity: `${item.querySelector(".quantity-input").value}`,
              selling_plan: "",
            };
            updatePlan(cartItem);
          }
        });
      }

      function selectUpdate(selector) {
        var select = selector.querySelector("select");
        select.addEventListener("change", (e) => {
          var thisSelect = e.target;
          var selectParent = e.target.closest("select-plan");
          var selectItem = selectParent.closest(".item");
          var selectCartItem = {
            id: `${selectParent.dataset.item}`,
            quantity: `${selectItem.querySelector(".quantity-input").value}`,
            selling_plan: `${
              thisSelect.options[thisSelect.selectedIndex].value
            }`,
          };
          thisSelect.style.color = "transparent";
          updatePlan(selectCartItem);
        });
      }

      function displayText(selector, plan) {
        return; // remove this to hide on demand
        if (plan) {
          
          selector.querySelector(".plan-1")
            ? (selector.querySelector(".plan-1").style.display = "block")
            : "";
          selector.querySelector(".plan-0")
            ? (selector.querySelector(".plan-0").style.display = "none")
            : "";
        } else {
          selector.querySelector("select")
            ? (selector.querySelector("select").style.display = "none")
            : "";
          selector.querySelector(".plan-0")
            ? (selector.querySelector(".plan-0").style.display = "block")
            : "";
          
        }
      }

      function getCartPlans(selector) {
        var thisItem = selector.dataset.item;
        var thisSelect = selector.querySelector("select");
        $s.getJson({
          url: "/cart.json",
          success: (data) => {
            data.items.forEach((item) => {
              if (thisItem == item.key && item.selling_plan_allocation) {
                thisSelect.value = item.selling_plan_allocation.selling_plan.id;
                thisSelect.style.color = "#000000";
              }
            });
          },
        });
      }

      function updatePlan(cartItem) {
        console.log("updating", cartItem, window.CartPage.postUpdate);
        if (window.SideCart) {
          window.SideCart.postChange(cartItem);
        } else if (window.CartPage) {
          window.CartPage.postChange(cartItem);
        }
      }
    }
  }
  customElements.define("select-plan", SelectPlan);
}
